export class Event {
  private readonly _code: string;
  private readonly _payload: any;

  constructor( code: string, payload?: any ) {
    this._code = code;
    this._payload = payload;
  }

  get code(): string {
    return this._code;
  }

  get payload(): string {
    return this._payload;
  }
}
